import angular from 'angular';

import Component from './UtilDropdown.component';

export default angular.module('petroCloud.utilDropdown', [])
  .component(Component.name, Component)
  .name;
